<script lang="ts">
	import type { Block as PageBlock } from '$models/Block/Block';
	import type { LandingPage } from '$models/Page/LandingPage';
	import Block from '$components/Block/Block.svelte';

	/**
	 * The page model to render.
	 */
	export let page: LandingPage;

	function getBlockKey(block: PageBlock, blockIndex: number): string {
		return `${page.id}:${block.htmlId ?? block.type}:${blockIndex}`;
	}
</script>

{#key page.id}
	{#each page.blocks as block, blockIndex (getBlockKey(block, blockIndex))}
		<Block {block} {page} {blockIndex} />
	{/each}
{/key}
